import SashiDo from 'lib/SashiDo';
import 'whatwg-fetch';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParseApp from 'lib/ParseApp';


export default class AppServerNotifcation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      server_status: '',
      isLoading: true,
    };
  }

  componentWillMount() {
    if (this.context.currentApp.server_status.state !== 'started') {
      this.hasServerInfo = this.context.currentApp.serverInfo && Object.keys(this.context.currentApp.serverInfo).length !== 0;
      clearInterval(this._server_check_interval);
      this.startServerChekcInterval();

      const checkHealth = fetch(`${this.context.currentApp.serverURL}health`)
        .then(response => response.json())
        .then((responseJson) => {
          this.checkHealth = responseJson.status === 'ok';
          return responseJson.status;
        })
        .catch(() => {
          // console.error(error);
        });

      return Promise.resolve(checkHealth);
    }
  }

  componentDidMount() {
    clearInterval(this._server_check_interval);
    this.startServerChekcInterval();
  }

  shouldComponentUpdate({ nextState }) {
    if (!nextState && this.state === nextState) {
      return false;
    }
    return true;
  }

  componentWillUpdate() {
    if (this.last_service_name !== this.context.currentApp.serviceName && this.hasServerInfo) {
      clearInterval(this._server_check_interval);
      this.startServerChekcInterval();
    }
  }

  componentWillUnmount() {
    if (this._server_check_interval) { clearInterval(this._server_check_interval); }
  }


  check() {
    const { serviceName, region } = this.context.currentApp;

    SashiDo.serverStatusCheck({ region, serviceName }).then(({ server, error }) => {
      if (error) {
        return;
      }

      let isLoading;
      if (server.state !== this.state.server_status || !this.hasServerInfo) {
        isLoading = true;
      }
      else {
        isLoading = false;
      }

      if (isLoading !== this.state.isLoading) {
        this.setState({ server_status: server.state, isLoading });
      }
    });
  }

  startServerChekcInterval() {
    this.last_service_name = this.context.currentApp.serviceName;

    if (this._server_check_interval) {
      clearInterval(this._server_check_interval);
      this._server_check_interval = null;
    }

    if (this.last_service_name) {
      this.check();
      this._server_check_interval = setInterval(() => this.check(), 10000);
    }
  }

  render() {
    return React.cloneElement(React.Children.only(this.props.children), { ...this.props });
  }
}

AppServerNotifcation.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp),
};
